import {
  MiddlewareAPI,
  isRejectedWithValue,
  Middleware,
} from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { clearSession } from "../features/auth/authSlice";

/**
 * Log a warning and show a toast!
 */
export const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
    if (isRejectedWithValue(action)) {
      console.warn("rtkQueryErrorLogger", action);
      const payload = action.payload as
        | { data?: { message?: string }; status?: number }
        | undefined;
      toast.error(
        payload?.data?.message
          ? `[${payload.status}] ${payload.data.message}`
          : (action.error as { message?: string })?.message ||
              "An error occurred"
      );
      if (payload?.status === 401) {
        // unauthorized , clear session n logout
        api.dispatch(clearSession());
      }
    }
    return next(action);
  };
